"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalTranslations = exports.useTranslations = void 0;
const react_1 = require("react");
const translations_1 = require("../../translations");
const ThemeProvider_1 = require("../../ThemeProvider/ThemeProvider");
const helpers_1 = require("./helpers");
const useTranslations = (translations) => {
    const lang = (0, react_1.useContext)(ThemeProvider_1.LanguageContext);
    const messages = translations[lang];
    return (path, vars) => {
        const message = (0, helpers_1.resolveMessage)(messages, path);
        return (0, helpers_1.injectVars)(message, vars);
    };
};
exports.useTranslations = useTranslations;
const useGlobalTranslations = () => {
    return (0, exports.useTranslations)(translations_1.translations);
};
exports.useGlobalTranslations = useGlobalTranslations;
//# sourceMappingURL=useTranslations.js.map